import { defineMessages } from 'react-intl';

// this will be not export, but formatjs can read this and generate our basic translations JSON File
// eslint-disable-next-line no-unused-vars
const dictionary = defineMessages({
  'Calendar.Events.error': {
    id: 'Calendar.Events.error',
    defaultMessage: 'Could not fetch events',
  },
});

export default {
  ...dictionary,
};
